// extracted by mini-css-extract-plugin
export default {"input":"mantineTextInput_input__oioz7"};